import React from "react";
import { Link } from "react-router-dom";
import CTAButton from "../CTAButton/CTAButton";
import TestimonialSlider from "../TestimonialSlider/TestimonialSlider";
import "./Segmentation.css";
import segmentPreview from "../../assets/segment.png";
import tailorPreview from "../../assets/tailor.png";

const Segmentation = () => {
  return (
    <div className="segmentation-page">
      <section className="segmentation-hero">
        <div className="hero-left">
          <Link to="/features" className="back-link">Back to features</Link>
          <h1>Email Segmentation for More Relevant Campaigns</h1>
          <p>Send highly targeted emails to the right people with powerful segmentation tools, subscriber tags, and audience data.</p>
          <div className="hero-form"><CTAButton>Get started</CTAButton></div>
        </div>
        <div className="hero-right">
          <img src={segmentPreview} alt="Email segmentation workflow preview" width="640" height="420" />
        </div>
      </section>

      <section className="seg-section">
        <div className="seg-left">
          <img src={tailorPreview} alt="Personalized email message preview" width="640" height="420" loading="lazy" />
        </div>
        <div className="seg-right">
          <h2>Make your emails more relevant</h2>
          <p>
            Decide who you want to deliver your message to and tailor your emails to speak directly to contacts that matter most within your audience list.
          </p>
        </div>
      </section>

      <TestimonialSlider title="Segmentation that makes campaigns feel more personal" />

      <section className="seg-section reverse">
        <div className="seg-left">
          <img src={segmentPreview} alt="Subscriber segment engagement preview" width="640" height="420" loading="lazy" />
        </div>
        <div className="seg-right">
          <h2>Drive more engagement</h2>
          <p>
            Tag your VIP subscribers to deliver content that is most relevant to them. Reward engagement with exclusive updates, offers, or content that builds loyalty.
          </p>
          <CTAButton className="primary-btn" kind="segmentation">Open segmentation tools</CTAButton>
        </div>
      </section>

      <section className="seg-section">
        <div className="seg-left">
          <h2>Manage your contacts more effectively</h2>
          <p>
            Segment your audience using the data that matters most to your business. Use custom fields to tag subscribers based on location, age, gender, or preferences.
          </p>
        </div>
        <div className="seg-right">
          <img src={tailorPreview} alt="Contact management and segmentation preview" width="640" height="420" loading="lazy" />
        </div>
      </section>

      <section className="cta-section">
        <h2>Start for free today</h2>
        <p>Sign up and send your first campaign in minutes. No credit card required.</p>
        <CTAButton className="primary-btn">Get started</CTAButton>
      </section>
    </div>
  );
};

export default Segmentation;
